function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(-103.000000, -485.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(49.000000, 291.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Bullet",
  transform: "translate(54.500000, 194.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-5",
  fill: "#EB8C01",
  opacity: 0.3,
  cx: 13,
  cy: 13,
  r: 13
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-5",
  fill: "#EB8C01",
  cx: 13,
  cy: 13,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-5",
  fill: "#DC6900",
  cx: 13,
  cy: 13,
  r: 4
})))));

const SvgBullet = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "27px",
  height: "26px",
  viewBox: "0 0 27 26",
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBullet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bullet.68f20f83.svg";
export { ForwardRef as ReactComponent };